/* import __COLOCATED_TEMPLATE__ from './user-details.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const UserDetails = templateOnlyComponent<Signature>();
export default UserDetails;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Onboarding::ConversationDetailsSidebar::UserDetails': typeof UserDetails;
    'inbox2/onboarding/conversation-details-sidebar/user-details': typeof UserDetails;
  }
}
